import React from 'react'
import styles from './school-avatar.styles'
import injectSheet from 'react-jss'
import Section from '../../../../shared/section/section'
import { PobbleAvatar } from 'pobble-components/dist/pobble-avatar'
import Button from 'pobble-components/dist/button'
import Description from '../../../../shared/description/description'
import FormFile from 'pobble-components/dist/form-elements/form-file'
import { openConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'

const SchoolAvatar = ({
  classes,
  pending,
  title,
  avatar,
  id,
  onRemove,
  onChange
}) => (
  <Section pending={pending}>
    <div className={classes.container}>
      <PobbleAvatar avatar={avatar} name={title} className={classes.avatar} />
      <div>
        <div className={classes.actions}>
          <FormFile accept=".jpg,.png" onChange={onChange}>
            <Button span tall wide secondary className={classes.button}>
              Upload image
            </Button>
          </FormFile>
          {avatar && (
            <Button
              simple
              tall
              action={() =>
                openConfirmationDialog({
                  bodyText: `Are you sure you want to remove the current school avatar?`,
                  confirmText: 'Yes',
                  action: () => onRemove(id)
                })
              }>
              Remove
            </Button>
          )}
        </div>
        <Description>
          Your avatar shows up on your school profile page. You can upload
          images up to 10mb.
        </Description>
      </div>
    </div>
  </Section>
)

export default injectSheet(styles)(SchoolAvatar)
